import { render } from "./SOS.vue?vue&type=template&id=eca1b3e2"
import script from "./SOS.vue?vue&type=script&lang=js"
export * from "./SOS.vue?vue&type=script&lang=js"

import "./SOS.vue?vue&type=style&index=0&id=eca1b3e2&lang=scss"

import exportComponent from "/home/runner/work/lifepass-passes-app/lifepass-passes-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__